module.exports = __webpack_public_path__ + "img/Quility-Logo-Text-Only-Forest-Green-RGB.18f9ccdb.svg";